import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import waitForSaga from 'helpers/waitForSaga';
import {
  ALL_VENUE_MARKETS,
  getAllVenueMarkets,
  selectAllVenueMarketsErrorContent,
  selectAllVenueMarketsHasError,
  selectAllVenueMarketsLoaded,
  selectAllVenueMarkets,
} from 'state/modules/venueMarkets';
import AllVenuesPage from 'views/AllVenuesPage';
import MetaDataMarkup from 'components/MetaDataMarkup';
import buildPageAnalytics from 'helpers/buildPageAnalytics';
import { ALL_VENUES_PAGE_NAME } from 'constants/pageNames';
import configureStore from 'state/configureStore';
import getServerSidePropsWrapper from 'helpers/getServerSidePropsWrapper';

const Venues = () => {
  const activeMarkets = useSelector((state) => selectAllVenueMarkets(state, ALL_VENUE_MARKETS));
  const openGraphProps = {
    description:
      'Looking for a venue or space for an upcoming event? The Bash will help you choose the best local event venue. Start here!',
    title: 'Find and book an event venue for your next party!',
    type: 'website',
    url: 'https://www.thebash.com/venues',
  };
  return (
    <>
      <MetaDataMarkup title="Explore Event Venues" openGraphProps={openGraphProps} />
      <AllVenuesPage activeMarkets={activeMarkets} />
    </>
  );
};

export const handleServerSideProps = async ({ store }) => {
  if (!selectAllVenueMarketsLoaded(store.getState(), ALL_VENUE_MARKETS)) {
    store.dispatch(getAllVenueMarkets());
  }

  await waitForSaga(store);

  let errorCode = null;
  if (selectAllVenueMarketsHasError(store.getState(), ALL_VENUE_MARKETS)) {
    errorCode = selectAllVenueMarketsErrorContent(store.getState(), ALL_VENUE_MARKETS);
  }

  const pageAnalytics = buildPageAnalytics(ALL_VENUES_PAGE_NAME);

  return {
    ...pageAnalytics,
    errorCode,
  };
};
export const getServerSideProps = configureStore.getServerSideProps(
  (store) => async (ctx) =>
    await getServerSidePropsWrapper({ ...ctx, store }, handleServerSideProps)
);

Venues.propTypes = {
  pageName: PropTypes.string.isRequired,
};

export default Venues;
